import { render, staticRenderFns } from "./RepoDetail.vue?vue&type=template&id=6019e796&scoped=true"
import script from "./RepoDetail.vue?vue&type=script&lang=js"
export * from "./RepoDetail.vue?vue&type=script&lang=js"
import style0 from "./RepoDetail.vue?vue&type=style&index=0&id=6019e796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6019e796",
  null
  
)

export default component.exports